// Track the visible viewport height in the --app-height CSS variable.
// The game-page CSS clamps it to 100svh (see globals.css --safe-vh), so a
// stale-large measurement — iOS Safari reports the bars-hidden height during
// initial load — can never push the board below the browser chrome. Never
// write inline height styles here: they would override that CSS clamp.

export function initViewport(): void {
  const setViewportHeight = () => {
    // visualViewport excludes browser chrome; innerHeight is the layout
    // viewport. Take the smaller of the two.
    let vh = window.innerHeight

    if (window.visualViewport) {
      vh = Math.min(window.visualViewport.height, window.innerHeight)
    }

    document.documentElement.style.setProperty('--app-height', `${vh}px`)
  }

  setViewportHeight()

  // iOS browsers can report a stale (bars-hidden) height during the first
  // moments after load and fire no resize event once it corrects — re-measure
  // a few times, and on first touch (always precedes gameplay)
  for (const delay of [50, 250, 1000]) {
    setTimeout(setViewportHeight, delay)
  }
  window.addEventListener('touchstart', setViewportHeight, { passive: true })

  window.addEventListener('resize', setViewportHeight)
  window.addEventListener('orientationchange', setViewportHeight)

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setViewportHeight)
    window.visualViewport.addEventListener('scroll', setViewportHeight)
  }
}
